import React, { Component } from "react";
import DinamicTable from "../../shared/table";
import { withTranslation } from 'react-i18next';
import IconShow from "canvas-core-react/lib/IconShow";
import StatusBadge from "canvas-core-react/lib/StatusBadge";
// import IconAddOutline from "canvas-core-react/lib/IconAddOutline";
import ActionMenuList from "canvas-core-react/lib/ActionMenuList";
import ActionMenuListItem from "canvas-core-react/lib/ActionMenuListItem";

export class TableClients extends Component {
  constructor(props) {
    super(props);
    this.state = { page: 0, sizePerPage: props.sizePerPage, menus: [] };
  }

  handleTableChange = ({ page, sizePerPage  }) => {
    const { getClientList, customFilters } = this.props;

    return getClientList(page, sizePerPage, customFilters).then(() => {
      this.setState({ page, sizePerPage });
    });
  };

  handleMenu = (id, open) => {
    const { menus } = this.state;
    menus[`menu-${id}`] = open;
    this.setState({menus});
  }

  getTableColumns = () => {
    const { t } = this.props;

    return [
      { selector: "institutionName", name: t("clients.table.name"), grow: 2 },
      { selector: "country", name: t("clients.table.country"), grow: 2 },
      { selector: "cif", name: t("clients.table.cif"), grow: 2 },
      { selector: "identification", name: t("clients.table.id"),grow: 2 },
      { selector: "status", name: t("clients.table.state"), center: true, grow: 2 },
      {
        name: t("clients.table.actions"),
        selector: "action",
        grow: 1,
        // center: true,
        cellFormatter: (row) => this.printOptions(row)
      },
    ];
  }

  printOptions = (row) => {
    const { action, actionlbl } = this.props;
    const { menus } = this.state;
    if ( null !== action ) {
      return <button
          className="button-table button--pill-table"
          onClick={() => this.setState({ menus: [] }, () => action(row.item))}>
            {actionlbl}
        </button>;
    } else {
      return <ActionMenuList
      bottomSheet={{
        heading: "Actions",
        secondaryAction: {
          onClick: () => {},
          label: "Cancel"
        }
      }}
      dialogPosition="bottom-right"
      isMenuOpen={ menus[`menu-${row.cif}`] || false }
      setIsMenuOpen={(open) => this.handleMenu(row.cif, open) }
      iconType="horizontal-small"
    >
      {this.getAction(row)}
    </ActionMenuList>
    }
  };

  setTableData() {
    var { t, data } = this.props;
    var estado = null;
    var cifC = null;
    var dataResult = [];

    if (data.length > 0) {
      data.map((item) => {
        if (item.company.status === "TRANSITORY") {
          estado = (
            <StatusBadge className="pending-client" type="default">
              {t("general.states.PENDING")}
            </StatusBadge>
          );
        } else if (item.company.pendingChange === true) {
          estado = (
            <StatusBadge className="pending-client" type="default">
              {t("general.states.PENDING_CHANGES")}
            </StatusBadge>
          );
        } else if (item.company.status === "ACTIVE") {
          estado = <StatusBadge className="success">{t("general.states.ACTIVE")}</StatusBadge>;
        } else if (item.company.status === "INACTIVE") {
          estado = (
            <StatusBadge className="error1" type="error">
              {t("general.states.INACTIVE")}
            </StatusBadge>
          );
        } else if (item.company.status === "REJECTED") {
          estado = (
            <StatusBadge className="rejected-payment" type="error">
              {t("general.states.REJECTED")}
            </StatusBadge>
          );
        }

        if (item.cif === null) {
          cifC = t("general.labels.cifMissing");
        } else {
          cifC = item.cif;
        }

        dataResult.push({
          companyId: item.company.id,
          institutionName: item.name,
          cif: cifC,
          identification: item.businessId,
          country: item.country.name,
          status: estado,
          item: item
        });
      });
    }

    return dataResult;
  }

  redirect = (id, url) => {
    const { menus } = this.state;
    menus[`menu-${id}`] = false;
    this.setState({ menus }, () => this.props.history.push(url));
  }

  getAction = (row) => {
    const { t } = this.props;
    let item = row.item;
    var id = `client-${item.cif}`;

    return <ActionMenuListItem
      icon={() => <IconShow id={id} className="TextButton__icon--left" />}
      onClick={() => this.redirect(row.cif, `/bscadministrator/edit/${item.company.id}`)}
      >
      {t("clients.table.view")}
    </ActionMenuListItem>
  };

  render() {
    const { page, sizePerPage } = this.state;
    const { totalSize } = this.props;
    return (
      <DinamicTable
        headers={this.getTableColumns()}
        data={this.setTableData()}
        page={page}
        totalSize={totalSize}
        sizePerPage={sizePerPage}
        onTableChange={this.handleTableChange}
      />
    );
  }
}

TableClients.defaultProps = {
  action: null,
  actionlbl: "",
};

export default (withTranslation()(TableClients));
